import { ChangeEvent, MouseEvent, useState } from "react";
import { ReactComponent as SearchIcon } from '../../../assets/Icons/adornments/Search.svg';
import { ReactComponent as ClearIcon } from '../../../assets/Icons/adornments/Close.svg';
import { OutlinedInput } from "@mui/material";

export default function FilterSearchBar({
    label,
    searchFn,
}: {
    label?: string,
    searchFn?: (searchQuery: string) => void,
}) {
    const [ input, setInput ] = useState('');

    const handleInput = (e:ChangeEvent<HTMLInputElement>) => {
        setInput(e.target.value);
        searchFn && searchFn(e.target.value);
    }

    return (
        <OutlinedInput 
            sx={{
                fontSize: '14px',
                fontFamily: 'Montserrat',
            }}
            inputProps={{
                style: {
                    padding: '8px 12px'
                }
            }}
            startAdornment={
                <div className="w-[16px] text-disable"><SearchIcon /></div>
            }
            endAdornment={
                input ? <button 
                            className="w-[24px] text-disable hover:text-primary transition-all"
                            onClick={(e: MouseEvent<HTMLButtonElement>) => {
                                e.preventDefault();
                                searchFn && searchFn('');
                                setInput('');
                            }}
                        >
                            <ClearIcon />
                        </button> 
                        : undefined
            }
            onChange={handleInput}
            // onKeyDown={(e) => {
            //     if (e.key === 'Enter') {
            //         searchFn && searchFn(input)
            //     }
            // }}
            placeholder={label ? label : 'Search'}
            value={input}
        />  
    )
}